<div
    *ngIf="sizes.length"
    class="format-list">
    <filter-list-sizes [sizes]="sizes"></filter-list-sizes>

    <ng-container *media="Breakpoint.DesktopUp">
        <filter-list-status *permissions="'Status'"></filter-list-status>
    </ng-container>
</div>
